import { RefreshCw, Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/button";
import { Input } from "../../../components/input";

export interface NewsToolbarProps {
  keyword: string;
  loading: boolean;
  onKeywordChange: (keyword: string) => void;
  onRefresh: () => void;
}

export function NewsToolbar({
  keyword,
  loading,
  onKeywordChange,
  onRefresh,
}: NewsToolbarProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <Input
        startIcon={<Search className="h-4 w-4 text-gray-400" />}
        placeholder={t("news.search_news")}
        value={keyword}
        onChange={(event) => onKeywordChange(event.target.value)}
        aria-label={t("news.search_news")}
        className="w-full lg:max-w-md"
      />
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        disabled={loading}
        className="flex items-center gap-2 self-start lg:self-auto"
      >
        <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
        {t("ui.refresh")}
      </Button>
    </div>
  );
}
